import { IWebsite } from '@/interfaces/huWebsite';

const websites: IWebsite[] = [
  {
    code: 'AM',
    hostnames: [
      'altomincio.huopenair.com',
      'altomincio-staging.huopenair.com',
      'altomincio-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'IP',
    hostnames: [
      'ipini.huopenair.com',
      'ipini-staging.huopenair.com',
      'ipini-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'BK',
    hostnames: [
      'birkelt.huopenair.com',
      'birkelt-staging.huopenair.com',
      'birkelt-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'NG',
    hostnames: [
      'norcenni.huopenair.com',
      'norcenni-staging.huopenair.com',
      'norcenni-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'PA',
    hostnames: [
      'parkalbatros.huopenair.com',
      'parkalbatros-staging.huopenair.com',
      'parkalbatros-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'ER',
    hostnames: ['eracleamare.huopenair.com', 'eracleamare-staging5.huopenair.com', 'eracleamare.huopenair.dev'],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl', 'da'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'MS',
    hostnames: [
      'montescudaio.huopenair.com',
      'montescudaio-staging.huopenair.com',
      'montescudaio-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'RO',
    hostnames: [
      'roma.huopenair.com',
      'roma-staging.huopenair.com',
      'roma-staging5.huopenair.com',
      'zealous-mud-05ce28f03.2.azurestaticapps.net'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'JO',
    hostnames: [
      'venezia.huopenair.com',
      'venezia-staging.huopenair.com',
      'venezia-staging5.huopenair.com',
      'polite-forest-0b5a17403.3.azurestaticapps.net'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'CFT',
    hostnames: [
      'firenze.huopenair.com',
      'firenze-staging.huopenair.com',
      'firenze-staging5.huopenair.com',
      'wonderful-field-048a93c03.1.azurestaticapps.net'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'FA',
    hostnames: [
      'fabulous.huopenair.com',
      'fabulous-staging.huopenair.com',
      'fabulous-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'CE',
    hostnames: [
      'staging.firenzecertosacamping.com',
      'firenzecertosacamping.com',
      'firenzecertosa.huopenair.com',
      'firenzecertosa-staging.huopenair.com',
      'firenzecertosa-staging5.huopenair.com'
    ],
    isMultiProperty: false,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@firenzecertosacamping.com',
      tel: '+390550299146'
    },
    logo: {
      path: 'logo_CE.svg',
      width: '200',
      height: '70',
      alt: 'Logo Certosa'
    }
  },
  {
    code: 'HU',
    hostnames: [
      'huopenair.com',
      'www.huopenair.com',
      'victorious-beach-0a321c803.3.azurestaticapps.net',
      'calm-wave-0554c8d03.6.azurestaticapps.net', // azb2c
      'test.huopenair.com',
      'happy-stone-061086003.1.azurestaticapps.net',
      'localhost'
    ],
    isMultiProperty: true,
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'VP',
    hostnames: [
      'palagina.it',
      'www.palagina.it',
      'test.palagina.it',
      'palagina.azurewebsites.net'
    ],
    isMultiProperty: true,
    showAvailabilityCategory: false,
    languages: ['en', 'it', 'de', 'nl', 'fr'],
    contacts: {
      mail: 'info@palagina.it',
      tel: '+390559502029'
    },
    logo: {
      path: 'logo_VP.svg',
      width: '70',
      height: '70',
      alt: ''
    }
  },
  {
    code: 'EV',
    hostnames: ['humantravel.com'],
    isMultiProperty: true,
    showAvailabilityCategory: false,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl', 'hu', 'da'],
    contacts: {
      mail: 'booking@huopenair.com',
      tel: '+390550298080'
    },
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70',
      alt: ''
    }
  }
];

export default websites;
